export enum EnumDisplayMode {
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY'
}
